import { Component } from '@angular/core';
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  env = environment.name;
  color = environment.color;
  title = 'admin';

  constructor() {}

  ngOnInit() {}
}
